import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { CollapseGameStateMachine } from '../../../reels_engine/collapse_reel_engine/collapse_game_state_machine';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';
import { ResourcesComponent } from '../resources_component';

interface ICollapseMultiplierAnimationComponentParams {
  entryThreshold: number;
  resetIfNoWin: boolean;
}

const DEFAULT_PARAMS: ICollapseMultiplierAnimationComponentParams = {
  entryThreshold: 0,
  resetIfNoWin: false,
};

export const COLLAPSE_MULTIPLIER_ANIMATION_COMPONENT_TOKEN = Symbol(
  'COLLAPSE_MULTIPLIER_ANIMATION_COMPONENT_TOKEN'
);

export class CollapseMultiplierAnimationComponent {
  constructor(
    container: Container,
    params: Partial<ICollapseMultiplierAnimationComponentParams> = {}
  ) {
    const { entryThreshold, resetIfNoWin } = { ...DEFAULT_PARAMS, ...params };

    const gameStateMachine: CollapseGameStateMachine<SpinResponse> =
      container.resolve<IGameStateMachineProvider>(GAME_STATE_MACHINE_PROVIDER_TOKEN)
        .gameStateMachine as CollapseGameStateMachine<SpinResponse>;

    const gameResourceProvider = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const multiplier = gameResourceProvider.root.findById('multiplier')!;

    gameStateMachine.beginCollapseState.entered.listen(() => {
      const collapseInfo = gameStateMachine.curResponse.collapseInfo;
      if (collapseInfo && collapseInfo.collapsingCounter > entryThreshold) {
        multiplier.stateMachine?.switchToState('next');
      }
    });

    gameStateMachine.accelerate.entered.listen(() =>
      multiplier.stateMachine?.switchToState('back')
    );

    if (resetIfNoWin) {
      gameStateMachine.animation.entered.listen(() =>
        multiplier.stateMachine?.switchToState('back')
      );
    }
  }
}
